/**
 * To use TooltipEdu module
 * HTML - create an element next to your target element with class name "tip" -> example code: pricing.html
 * Javascript - import the Tooltip -> require('../components/tooltip').tooltip;
 *            - initial it with target element class name -> tooltip.init($(".js_plan-tool-tip"));
 */

const ua = require('./ua');

let TooltipEdu = function() {
};

TooltipEdu.prototype.init = function($targetElement) {
  let self = this;
  this.$tooltip = $("<div class='tooltip'><div class='arrow-up'></div><div class='text'></div></div>");
  $('body').append(this.$tooltip);
  $targetElement.each(function(){
    self.attachEvent($(this));
  });

};

TooltipEdu.prototype.attachEvent = function($targetElement) {
  let self = this;

  if (ua.isiPhone || ua.isTablet) {
    $targetElement.click(
      function() {
        let tooltipText = $('.tip', $(this).parent()).html();
        self.$tooltip.find(".text").html(tooltipText);
        self.show();
        self.updatePosition($(this));
      }
    );
    $(document).on("touchstart click", function() {
      if(self.isShow()) {
        self.hide(); 
      }
    });
    
  } else {
    $targetElement.hover(
      function() {
        let tooltipText = $('.tip', $(this).parent()).html();
        self.$tooltip.find(".text").html(tooltipText);
        self.show();
        self.updatePosition($(this));
      },
      function() {
        self.hide();
      }
    )
  }
};

TooltipEdu.prototype.updatePosition = function($targetElement) {
  let gap = 30;
  let $arrow = this.$tooltip.find(".arrow-up");
  let arrowWidth = parseInt($arrow.css("border-left-width").replace("px", ""));
  
  if($(document).width() < 1020) {
    this.$tooltip.css({
      "left": $targetElement.offset().left + 5,
      "top": $targetElement.offset().top  + $targetElement.height() + arrowWidth + gap
    });
  } else {
    this.$tooltip.css({
      "left": $targetElement.offset().left - gap - this.$tooltip.width(),
      "top": $targetElement.offset().top
    });
  }
};

TooltipEdu.prototype.show = function(){
  this.$tooltip.css({
    "opacity": 1,
    "visibility": "visible"
  });
};

TooltipEdu.prototype.isShow = function(){
  return this.$tooltip.css('visibility') !== 'hidden';
};

TooltipEdu.prototype.hide = function() {
  this.$tooltip.css({
    "opacity": 0,
    "visibility": "hidden"
  });
};

module.exports.tooltipEdu = new TooltipEdu();
